import React, { memo } from 'react'
import { useSocialLinks, SocialLinksProps } from './useSocialLinks'
import styles from './SocialLinks.module.scss'

const SocialLinks: React.FC<SocialLinksProps> = (props: SocialLinksProps) => {
  const { Links } = useSocialLinks(props)

  return (
    <div className={styles['social-links']}>
      {Links.whatsapp && (
        <a href={Links.whatsapp} target='_blank' rel='noreferrer'>
          <i title='Whatsapp' className='bi bi-whatsapp fs-5 me-3'></i>
        </a>
      )}
      {Links.instagram && (
        <a href={Links.instagram} target='_blank' rel='noreferrer'>
          <i title='Instagram' className='bi bi-instagram fs-5 me-3'></i>
        </a>
      )}
      {Links.facebook && (
        <a href={Links.facebook} target='_blank' rel='noreferrer'>
          <i title='Facebook' className='bi bi-facebook fs-5 me-3'></i>
        </a>
      )}
      {Links.tiktok && (
        <a href={Links.tiktok} target='_blank' rel='noreferrer'>
          <i title='TikTok' className='bi bi-tiktok fs-5 me-3'></i>
        </a>
      )}
      {Links.threads && (
        <a href={Links.threads} target='_blank' rel='noreferrer'>
          <i title='Threads' className='bi bi-threads fs-5 me-3'></i>
        </a>
      )}
      {Links.x && (
        <a href={Links.x} target='_blank' rel='noreferrer'>
          <i title='X' className='bi bi-twitter-x fs-5 me-3'></i>
        </a>
      )}
      {Links.linkedin && (
        <a href={Links.linkedin} target='_blank' rel='noreferrer'>
          <i title='LinkedIn' className='bi bi-linkedin fs-5 me-3'></i>
        </a>
      )}
      {Links.youtube && (
        <a href={Links.youtube} target='_blank' rel='noreferrer'>
          <i title='Youtube' className='bi bi-youtube fs-5'></i>
        </a>
      )}
    </div>
  )
}

export default memo(SocialLinks)
